import React from "react";

export function MessagesTab({ ctx }) {
  const { messages } = ctx;
  return (
      <div>
        <h1 className="serif text-3xl mb-8">Enquiries</h1>
        {messages.length === 0 ? <p className="text-[#8A857D]">No enquiries yet.</p> : (
          <div className="space-y-4">
            {messages.map((m) => (
              <div key={m.id} className="border border-[#262421] p-5">
                <div className="flex justify-between"><span className="serif text-lg">{m.name}</span><span className="text-xs text-[#8A857D]">{new Date(m.created_at).toLocaleString()}</span></div>
                <p className="text-xs text-[#C49A6C] mt-1">{m.email}</p>
                <p className="text-sm text-[#8A857D] mt-3 whitespace-pre-wrap">{m.message}</p>
              </div>
            ))}
          </div>
        )}
      </div>
  );
}
